/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code which indicates the compass direction. Like SAP-OrientationCode, but without the \"unknown\" and \"horizontal\" options. 
 */
export type SAPCompassDirectionCodeUIDTOV0 = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | 'ND';

export const SAPCompassDirectionCodeUIDTOV0 = {
    _1: '1' as SAPCompassDirectionCodeUIDTOV0,
    _2: '2' as SAPCompassDirectionCodeUIDTOV0,
    _3: '3' as SAPCompassDirectionCodeUIDTOV0,
    _4: '4' as SAPCompassDirectionCodeUIDTOV0,
    _5: '5' as SAPCompassDirectionCodeUIDTOV0,
    _6: '6' as SAPCompassDirectionCodeUIDTOV0,
    _7: '7' as SAPCompassDirectionCodeUIDTOV0,
    _8: '8' as SAPCompassDirectionCodeUIDTOV0,
    Nd: 'ND' as SAPCompassDirectionCodeUIDTOV0
};

